import { render, staticRenderFns } from "./r-simple-card.vue?vue&type=template&id=2cbdaaa8"
import script from "./r-simple-card.vue?vue&type=script&lang=js"
export * from "./r-simple-card.vue?vue&type=script&lang=js"
import style0 from "./r-simple-card.vue?vue&type=style&index=0&id=2cbdaaa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports